module.exports = __webpack_public_path__ + "img/13.719e8983.png";